import { DailyTemperatureData, GCHPredictionInput, SummaryData, VarietalPredictions } from '../grapeColdHardiness-NYUS21/modelNYUS2_1-types';

const GCH_PREDICT_SUBDOMAIN_URL = process.env.GATSBY_NEWA_GCH_PREDICT_URL

export const getSummaryData = async ({dailyWeatherData, selectedCultivar, latitude}: {
  dailyWeatherData: DailyTemperatureData[],
  selectedCultivar: string,
  latitude: number
}): Promise<SummaryData[]> => {
  const body: GCHPredictionInput = {
    data: {
      dailyWeatherData,
      selectedCultivars: [selectedCultivar],
      latitude,
    }
  }

  const response = await fetch(GCH_PREDICT_SUBDOMAIN_URL, {
    method: 'POST',
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`Cold hardiness prediction API returned ${response.status}`);
  }

  const  { data }: { data: VarietalPredictions[] } = await response.json();
  const { predictions: calculations } = data[0]; // since we're only fetching one cultivar, just grab the first returned
  const summaryData: SummaryData[] = [];

  for (let i = 0; i < calculations.length; i++) {
    const date = calculations[i].date;
    const matchingWeatherDataIndex = dailyWeatherData.findIndex(({date: dailyWeatherDataDate}) => dailyWeatherDataDate.toJSON() === date);
    const isForecast = matchingWeatherDataIndex !== -1 ? dailyWeatherData[matchingWeatherDataIndex].isForecast : false;
    // Let's get these number trimmed up a bit for display
    const lt50_celsius = Math.round(calculations[i].lt50_celsius * 10) / 10;
    const maxT_celsius = Math.round(calculations[i].maxT_celsius * 10) / 10;
    const minT_celsius = Math.round(calculations[i].minT_celsius * 10) / 10;
    const lt50_fahrenheit =
      Math.round((lt50_celsius * (9 / 5) + 32) * 10) / 10;
    const maxT_fahrenheit =
      Math.round((maxT_celsius * (9 / 5) + 32) * 10) / 10;
    const minT_fahrenheit =
      Math.round((minT_celsius * (9 / 5) + 32) * 10) / 10;

    const record = {
      date,
      isForecast,
      lt50_celsius,
      maxT_celsius,
      minT_celsius,
      lt50_fahrenheit,
      maxT_fahrenheit,
      minT_fahrenheit,
    };

    summaryData.push(record);
  }

  return summaryData;
}
